
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Container } from "inversify";
@Component({
    components: {},
    filters: {},
})
export default class UserOrganizationAffiliation extends Vue {
    @Inject("container") readonly container!: Container;
    @Prop() organization!: any;

    get organizationUrl() {
        return `/dashboard/organizations/${this.organization.organizationid}`;
    }
}
